import request from "superagent";

/**
 * http helper for sending GraphQL requests to the assignment service
 * @param {string} query - assignment GraphQL query
 * @param {object} variables - assignment GraphQL query variables
 * @returns {Promise<*>}
 */
async function graphqlRequest<T>(
  query: string,
  variables: Record<string, any>
): Promise<T> {
  const baseUrl = process.env.SKILLS_MASTERY_URL;
  if (!baseUrl) {
    throw new Error("SKILLS_MASTERY_URL is not defined");
  }
  const response = await request.post(baseUrl)
    .set('x-api-key', process.env.SKILLS_MASTERY_KEY!)
    .set('Content-Type', 'application/json')
    .send({query: query, variables});
    
  const {body} = response;

  if (body.errors) {
    console.log(body.errors)
    throw new Error(body.errors[0].message);
  }

  return body.data;
}

export default graphqlRequest;